import {TLoggerType} from 'core/modules/logger';
import {readPublicRuntimeEnv} from 'core/helpers/env/runtime';

const envFlag = (value?: string): boolean => 'true' === value?.trim().toLowerCase();

export const NEXT_PUBLIC_API_HOST = readPublicRuntimeEnv('NEXT_PUBLIC_API_HOST') as string;

export const API_VERSION = readPublicRuntimeEnv('API_V') || 'platform/api/v1';

export const NEXT_PUBLIC_STATIC_HOST =
    readPublicRuntimeEnv('NEXT_PUBLIC_STATIC_HOST') || 'https://static.simplewine.ru';

export const NEXT_PUBLIC_MASTER_HOST = readPublicRuntimeEnv('NEXT_PUBLIC_MASTER_HOST') || 'https://simplewine.ru';

export const NEXT_PUBLIC_MAPBOX_TOKEN = readPublicRuntimeEnv('NEXT_PUBLIC_MAPBOX_TOKEN') as string;

export const GTM_API_KEY = readPublicRuntimeEnv('GTM_API_KEY') as string;

export const NEXT_PUBLIC_GF_SECTION_ID = readPublicRuntimeEnv('NEXT_PUBLIC_GF_SECTION_ID') as string;

export const NEXT_PUBLIC_CAPTCHA_KEY = readPublicRuntimeEnv('NEXT_PUBLIC_CAPTCHA_KEY') as string;

export const NEXT_PUBLIC_ONLINE_CHAT_ID = readPublicRuntimeEnv('NEXT_PUBLIC_ONLINE_CHAT_ID') as string;

export const NEXT_PUBLIC_YM_COUNTER_NUMBER = readPublicRuntimeEnv('NEXT_PUBLIC_YM_COUNTER_NUMBER') as string;

export const NEXT_PUBLIC_GF_WRIMP_ENABLED = envFlag(readPublicRuntimeEnv('NEXT_PUBLIC_GF_WRIMP_ENABLED'));

export const NEXT_PUBLIC_GF_CLICK_ENABLED = envFlag(readPublicRuntimeEnv('NEXT_PUBLIC_GF_CLICK_ENABLED'));

export const CACHE_USER_SESSION = envFlag(readPublicRuntimeEnv('CACHE_USER_SESSION'));

export const NEXT_PUBLIC_LOGGER_TYPE =
    (readPublicRuntimeEnv('NEXT_PUBLIC_LOGGER_TYPE') as TLoggerType) || 'JSON_CONSOLE';

export const NEXT_PUBLIC_WINTER_DESIGN = envFlag(readPublicRuntimeEnv('NEXT_PUBLIC_WINTER_DESIGN'));
